import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageProjectsList from 'hcp/components/page/projects/list';

<template>
  {{pageTitle (t "page-title.projects.list")}}

  <PageProjectsList
    @currentPageSize={{@model.currentPageSize}}
    @lastOpenedProject={{@model.lastOpenedProject}}
    @onPageSizeChange={{@onPageSizeChange}}
    @organization={{@model.organization}}
    @pagination={{@model.pagination}}
    @projects={{@model.projects}}
    @query={{@model.query}}
    @resourcePermissions={{@model.resourcePermissions}}
  />
</template>
